import {Component, OnInit} from '@angular/core';
import {ValidatorEditorService} from '../validator-editor.service';
import {AbstractEditorComponent} from '../abstract-editor.component';
import * as moment from 'moment';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';

@Component({
    selector: 'dmp-date-editor',
    templateUrl: './date-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class DateEditorComponent extends AbstractEditorComponent implements OnInit {


    showTime = false;
    onlyTime = false;

    constructor(protected validatorService: ValidatorEditorService,
                protected fb: FormBuilder) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return this.validatorService.doTransform(this.field, value);
    }

    ngOnInit(): void {
        this.init();
        let currentValue: Date = null;
        if (this.disable === false && moment(this.value).isValid()) {
            currentValue = moment(this.value).toDate();
            this.showTime = this.value ? this.value.length > 10 : false;
        } else if (this.disable === false && this.isTime(this.value)) {
            const segments = this.value.split(':');
            const hours = parseInt(segments[0]);
            const minutes = parseInt(segments[1]);
            const seconds = parseInt(segments[2]);
            currentValue = moment().hours(hours).minutes(minutes).seconds(seconds).milliseconds(0).toDate();
            this.onlyTime = true;
        } else {
            currentValue = null;
        }
        if (currentValue) {
            this.formGroup.get('value').setValue(currentValue);
        }
    }

    private isTime(value) {
        return value && value.length === 8 && this.value.split(':').length === 3;
    }

    onChange(value: Date) {
        console.log(value);
    }

/*    save(event) {
        if (this.currentValue != null) {
            const valueString = this.validatorService.doTransform(this.field, this.currentValue);
            this.valueEditorChange.emit({
                value: valueString,
                status: true});
            this.valueChange.emit(this.value);
            this.focusOut(event);
        }
    }*/
}
